import React from 'react';
import { FaTimes, FaTrophy, FaInfoCircle } from 'react-icons/fa';
import { format } from 'date-fns';

const NotificationDetailModal = ({ notification, onClose }) => {
  if (!notification) return null;
  
  // Create a title from the first part of the message or based on notification type
  const message = notification.message || notification.content || '';
  const colonIndex = message.indexOf(':');
  
  // Determine title based on notification type
  let title;
  if (notification.type === 'mention') {
    title = 'Match Report Mention';
  } else if (notification.type === 'achievement') {
    title = 'Achievement Unlocked';
  } else if (notification.type === 'last_match') {
    title = 'Match Update';
  } else if (notification.type === 'update') {
    title = 'Team Update';
  } else if (notification.title) {
    title = notification.title;
  } else if (colonIndex > 0) {
    title = message.substring(0, colonIndex).trim();
  } else {
    title = notification.type === 'announcement' ? 'Announcement' : 'Notification';
  }
  
  // Format the content based on notification type
  const renderDetailContent = () => {
    switch(notification.type) {
      case 'mention':
        // Parse the match mention message
        const hasBeenIndex = message.indexOf('has been');
        if (hasBeenIndex > 0) {
          let playerName = message.substring(0, hasBeenIndex).trim();
          const matchReportIndex = message.indexOf('match report');
          const finalColonIndex = message.lastIndexOf(':');
          
          // Check if player name contains an achievement
          let achievementName = '';
          const dashIndex = playerName.indexOf(' - ');
          if (dashIndex > 0) {
            achievementName = playerName.substring(dashIndex + 3);
            playerName = playerName.substring(0, dashIndex);
          }
          
          if (matchReportIndex > 0 && finalColonIndex > matchReportIndex) {
            const matchDescription = message.substring(matchReportIndex + 13, finalColonIndex).trim();
            const comment = message.substring(finalColonIndex + 1).trim();
            
            return (
              <div className="mention-detail">
                {achievementName && (
                  <div className="achievement-name-detail">
                    <strong>Achievement:</strong> {achievementName}
                  </div>
                )}
                <div className="match-description-detail">
                  <strong>Match:</strong> {matchDescription}
                </div>
                <div className="mention-comment-detail">
                  <strong>Coach's Comment:</strong> 
                  <p>{comment}</p>
                </div>
              </div>
            );
          }
        }
        break;
        
      case 'achievement':
        return (
          <div className="achievement-detail">
            <div className="achievement-icon-large">
              <FaTrophy size={30} color="#FFC107" />
            </div>
            <p className="achievement-message">{message}</p>
          </div>
        );
        
      case 'last_match':
      case 'update':
        return (
          <div className="update-detail">
            <div className="update-icon">
              <FaInfoCircle size={20} color="#2196F3" />
            </div>
            <p className="update-message">{message}</p>
          </div>
        );
        
      default:
        return <p>{message}</p>;
    }
    
    // Default fallback
    return <p>{message}</p>;
  };
  
  return (
    <div className="notification-modal-overlay" onClick={onClose}>
      <div className="notification-modal" onClick={(e) => e.stopPropagation()}>
        <div className="notification-modal-header">
          <h2>{title}</h2>
          {notification.isRead !== undefined && (
            <span className={`read-status ${notification.isRead ? 'read' : 'unread'}`}>
              {notification.isRead ? 'Read' : 'Unread'}
            </span>
          )}
          <button className="close-button" onClick={onClose}>
            <FaTimes />
          </button>
        </div>
        
        {notification.timestamp && (
          <div className="notification-modal-time">
            {format(notification.timestamp, 'PPpp')}
          </div>
        )}
        
        <div className="notification-modal-content">
          {renderDetailContent()}
          
          {notification.actions && notification.actions.length > 0 && (
            <div className="notification-actions">
              {notification.actions.map((action, index) => (
                <button key={index} className="action-button">
                  {action.label}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NotificationDetailModal; 